/*
 * @Description: 
 * @Date: 2025-09-01 10:22:20
 * @LastEditTime: 2026-08-04 13:12:33
 * @FilePath: \hui_ai_ui\src\api\ai\agent.js
 */
import { dynamicService } from '../index'; // ◀️ 1. 导入新的 dynamicService
import { getApiBaseUrl, isTauri, getWsBaseUrl } from '@/config';
// 获得所有智能体
export function fetchAgentApi(data) {
  const path = "/api/v1/bot/bots"; // ◀️ 2. 只需定义路径
  // 3. 使用 dynamicService，并将 data 作为 params。这是axios.get的标准用法
  return dynamicService.get(path, { params: data });
}
// 搜索的智能体
export function searchAgentApi(data) {
  const path = "/api/v1/bot/bots";
  return dynamicService.get(path, { params: data });
}
// 创建智能体
export function createAgentApi(data) {
  const path = "/api/v1/bot/bots";
  return dynamicService.post(path, data);
}
// 删除智能体 (注意：您之前写的可能是 detele，应该是 delete)
export function deleteAgentApi(id) {
  const path = `/api/v1/bot/bots/${id}`;
  return dynamicService.delete(path);
}
// 获得指定智能体
export function fetchAgentDetailApi(id) {
  const path = `/api/v1/bot/bots/${id}`;
  return dynamicService.get(path);
}
// 修改指定智能体
export function updateAgentApi(id, data) {
  const path = `/api/v1/bot/bots/${id}`;
  return dynamicService.put(path, data);
}
// 用户反馈列表
export function getFeedbackList(data) {
  const path = "/api/v1/feedback/list";
  return dynamicService.get(path, { params: data });
}
// 获得反馈详情
export function getFeedbackDetail(id, data) {
  const path = `/api/v1/feedback/${id}`;
  return dynamicService.get(path, { params: data });
}
// 修改反馈
export function updateFeedbackApi(id) {
  const path = `/api/v1/feedback/${id}`;
  return dynamicService.put(path);
}
// 删除反馈
export function deleteFeedbackApi(id, data) {
  const path = `/api/v1/feedback/${id}`;
  return dynamicService.delete(path, { params: data });
}
// 添加反馈
export function addFeedbackApi(data) {
  const path = "/api/v1/feedback/add";
  return dynamicService.post(path, data);
}

// 创建蒸馏数字人
export function createDBotApi(data) {
  const path = "/api/v1/bot/nuwa";
  return dynamicService.post(path, data);
}
// 数字人头像上传
export function uploadDBotAva(data) {
  const path = "/api/v1/bot/avatar/upload";
  return dynamicService.post(path, data);
}
// 数字人语音上传
export function uploadDBotVoice(data) {
  const path = "/api/v1/bot/voice/upload";
  return dynamicService.post(path, data);
}
// 数字人视频上传 (需要传user_id)
export function uploadDBotVideo(data) {
  const path = "/api/v1/bot/video/upload";
  return dynamicService.post(path, data);
}
// 创建公证数字人
export function createNotaryApi(data) {
  const path = "/api/v1/bot/notary";
  return dynamicService.post(path, data);
}
// 修改公证数字人
export function updateNotaryApi(botId, data) {
  const path = `/api/v1/bot/notary/${botId}`;
  return dynamicService.put(path, data);
}
// 删除公证数字人
export function deleteNotaryApi(botId) {
  const path = `/api/v1/bot/notary/${botId}`;
  return dynamicService.delete(path);
}
// 获取公证数字人详情
export function fetchNotaryDetailApi(botId) {
  const path = `/api/v1/bot/notary/${botId}`;
  return dynamicService.get(path);
}
// 获取公证数字人列表
export function fetchNotaryListApi(params) {
  const path = "/api/v1/bot/notary/list";
  return dynamicService.get(path, { params });
}
// 检查公证数字人名称是否唯一
export function checkNotaryName(params) {
  const path = "/api/v1/bot/notary/name/check";
  return dynamicService.get(path, { params });
}
// 修改蒸馏数字人
export function updateDBotApi(botId, data) {
  const path = `/api/v1/bot/nuwa/${botId}`;
  return dynamicService.put(path, data);
}

// 删除蒸馏数字人
export function deleteDBotApi(botId) {
  const path = `/api/v1/bot/nuwa/${botId}`;
  return dynamicService.delete(path);
}
export function searchDBotApi(data) {
  const path = "/api/v1/bot/nuwa/list";
  return dynamicService.get(path, { params: data });
}

// 获取蒸馏数字人详情
export function fetchDBotDetailApi(botId) {
  const path = `/api/v1/bot/nuwa/${botId}`;
  return dynamicService.get(path);
}

// 获取蒸馏数字人列表
export function fetchDBotListApi(params) {
  const path = "/api/v1/bot/nuwa/list";
  return dynamicService.get(path, { params });
}
// 获取音色列表
export function fetchVoiceListApi(params) {
  const path = "/api/v1/voice/list";
  return dynamicService.get(path, { params });
}
// 获取视频列表
export function fetchVideoListApi(params) {
  const path = "/api/v1/video/list";
  return dynamicService.get(path, { params });
}
// 检查蒸馏数字人名称是否唯一
export function checkDBotName(params) {
  const path = "/api/v1/bot/nuwa/name/check";
  return dynamicService.get(path, { params });
}

// 管理反馈列表
// 获取用户反馈通知
export function getFeedbackNotice(data) {
  const path = "/api/v1/feedback/user/notice";
  return dynamicService.get(path, { params: data });
}
export function delFeedbackNotice(data) {
  const path = "/api/v1/feedback/user/notice";
  return dynamicService.delete(path, { params: data });
}
// 获取用户反馈通知列表
export function getFeedbackNoticeList(data) {
  const path = "/api/v1/feedback/user/notice/list";
  return dynamicService.get(path, { params: data });
}
// 用户阅读消息通知
export function readFeedbackNotice(noticeId, data) {
  const path = `/api/v1/feedback/user/notice/read/${noticeId}`;
  return dynamicService.get(path, { params: data });
}
// 管理员阅读用户的反馈信息
export function adminReadFeedback(feedbackId, data) {
  const path = `/api/v1/feedback/admin/read/${feedbackId}`;
  return dynamicService.get(path, { params: data });
}
// 管理员回复用户的反馈
export function adminReplyFeedback(feedbackId, data) {
  const path = `/api/v1/feedback/admin/reply/${feedbackId}`;
  return dynamicService.put(path, data);
}
// 管理员获取所有用户的反馈列表
export function getAdminFeedbackList(data) {
  const path = "/api/v1/feedback/admin/feedback/list";
  return dynamicService.get(path, { params: data });
}

// 获取历史对话列表
export function getChatSessionList(data) {
  const path = "/api/v1/chat_session/list";
  return dynamicService.get(path, { params: data });
}
// 获取聊天会话历史记录
export function getChatSessionHistory(id, data) {
  const path = `/api/v1/chat_session/${id}`;
  return dynamicService.get(path, { params: data });
}
// 删除聊天会话
export function deleteChatSessionApi(id, params) {
  const path = `/api/v1/chat_session/${id}`;
  return dynamicService.delete(path, { data: params });
}
// 重命名聊天会话标题
export function renameChatSessionTitle(id, data) {
  const path = `/api/v1/chat_session/${id}/rename`;
  return dynamicService.put(path, data);
}

// 设置聊天会话置顶
export function setChatSessionTop(id, data) {
  const path = `/api/v1/chat_session/${id}/set_top`;
  return dynamicService.put(path, data);
}

// 设置智能体置顶/取消置顶
export function setBotTop(botId, data) {
  const path = `/api/v1/bot/${botId}/set_top`;
  return dynamicService.put(path, data);
}

// 搜索聊天会话和内容
export function searchChatSessionApi(data) {
  const path = "/api/v1/chat_session/chat/search";
  return dynamicService.get(path, { params: data });
}

// 编辑数字人
export function editdigital(id, data) {
  const path = `/api/v1/bot/nuwa/${id}`;
  return dynamicService.put(path, data);
}

// 获取智能体/数字人可见范围列表
export function getBotVisibilityList(botId, params) {
  const path = `/api/v1/bot/bots/${botId}/visibility/list`;
  return dynamicService.get(path, { params });
}

// 添加智能体/数字人可见范围
export function addBotVisibility(botId, data) {
  const path = `/api/v1/bot/bots/${botId}/visibility`;
  return dynamicService.post(path, data);
}

// 删除智能体/数字人可见范围
export function deleteBotVisibility(botId, params) {
  const path = `/api/v1/bot/bots/${botId}/visibility`;
  return dynamicService.delete(path, { data: params });
}

// 开始蒸馏 (流式响应)
export function distill(params) {
  const baseUrl = getApiBaseUrl();
  const url = baseUrl + `/api/v1/nuwa/distill`;
  const headers = { "Content-Type": "application/json" };
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(params),
    headers: headers,
  });
}

// 上传参考资料 (流式响应)
export function updistill(formData) {
  const baseUrl = getApiBaseUrl();
  const url = baseUrl + `/api/v1/nuwa/distill/upload`;
  const headers = {};
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "POST",
    body: formData,
    headers: headers,
  });
}

// 技能对话 (流式响应)
export function nuwask(params) {
  const baseUrl = getApiBaseUrl();
  const url = baseUrl + `/api/v1/nuwa/ask`;
  const headers = { "Content-Type": "application/json" };
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(params),
    headers: headers,
  });
}

export function sendNuwaApi(params) {
  const baseUrl = getApiBaseUrl(); // ◀️ 2. 在调用时动态获取正确的域名
  const url = baseUrl + `/api/v1/nuwa_chat/send`; // v4 知识库多文件
  const headers = { "Content-Type": "application/json" };
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(params),
    headers: headers,
  });
}

export function sendChatGuestApi(params) {
  const baseUrl = getApiBaseUrl();
  const url = baseUrl + `/api/v1/nuwa_chat/guest/send`;
  const headers = { "Content-Type": "application/json" };
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(params),
    headers: headers,
  });
}

// 上传图片
export function uploadImageToOSS(formData) {
  const baseUrl = getApiBaseUrl();
  const url = baseUrl + `/api/v1/oss/feedback/upload/attachment`;
  const headers = {};
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "POST",
    body: formData,
    headers
  });
}
// ─────────────────────────────────────────────────────────────
//  WebSocket 语音助手
// ─────────────────────────────────────────────────────────────
const CFG = {
  MIC_SAMPLE_RATE: 16000,
  TTS_SAMPLE_RATE: 24000,
  PING_INTERVAL_MS: 12000,
  PONG_TIMEOUT_MS: 45000,
  RECONNECT_DELAY: 1200,
  RECONNECT_MAX_DELAY: 12000,
};

let ws = null;
let reconnectTimer = null;
let reconnectAttempts = 0;
let lastPongAt = 0;
let pingTimer = null;
let messageCallback = null;
let stateCallback = null;
let cachedBotId = null;
let stopReconnect = false;

function getWsUrl(botId) {
  // 桌面端（Electron app://hui）不能用 location.host 拼地址，统一由 getWsBaseUrl 推导
  return `${getWsBaseUrl()}/ws/voice?bot_id=${botId}`;
}

export function initWebSocket(msgCallback, stateCb) {
  messageCallback = msgCallback;
  stateCallback = stateCb;
}

export function connectWebSocket(botId) {
  clearTimeout(reconnectTimer);
  reconnectTimer = null;
  
  // 如果已停止重连，则不再连接
  if (stopReconnect) {
    return;
  }
  
  // 缓存 botId（用于重连）
  if (botId !== undefined && botId !== null) {
    cachedBotId = botId;
  }
  
  if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) {
    return;
  }

  ws = new WebSocket(getWsUrl(cachedBotId));
  const socket = ws;
  ws.binaryType = 'arraybuffer';

  ws.onopen = () => {
    if (ws !== socket) return;
    reconnectAttempts = 0;
    lastPongAt = Date.now();
    if (stateCallback) {
      stateCallback('connected');
    }
    startPingLoop();
  };

  ws.onclose = () => {
    if (ws !== socket) return;
    if (stateCallback) {
      stateCallback('disconnected');
    }
    stopPingLoop();
    scheduleReconnect();
  };

  ws.onerror = () => {
    try { socket.close(); } catch {}
  };

  ws.onmessage = (e) => {
    if (ws !== socket) return;
    lastPongAt = Date.now();
    if (e.data instanceof ArrayBuffer) {
      if (messageCallback) {
        messageCallback({ type: 'audio', data: e.data });
      }
    } else {
      try {
        const msg = JSON.parse(e.data);
        // 检测到数字人不存在错误，停止重连
        if (msg.type === 'error' && msg.code === 404) {
          stopReconnect = true;
          disconnectWebSocket();
        }
        if (messageCallback) {
          messageCallback(msg);
        }
      } catch (err) {
        console.error('解析WebSocket消息失败:', err);
      }
    }
  };
}

function wsSend(data) {
  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(data);
    return true;
  }
  connectWebSocket();
  return false;
}

export function wsSendJSON(obj) {
  return wsSend(JSON.stringify(obj));
}

export function wsSendBinary(data) {
  return wsSend(data);
}

function scheduleReconnect() {
  clearTimeout(reconnectTimer);
  const delay = Math.min(
    CFG.RECONNECT_DELAY * Math.pow(1.6, reconnectAttempts++),
    CFG.RECONNECT_MAX_DELAY,
  );
  reconnectTimer = setTimeout(connectWebSocket, delay);
}

function startPingLoop() {
  stopPingLoop();
  pingTimer = setInterval(() => {
    if (!ws || ws.readyState !== WebSocket.OPEN) {
      connectWebSocket();
      return;
    }
    if (Date.now() - lastPongAt > CFG.PONG_TIMEOUT_MS) {
      try { ws.close(); } catch {}
      return;
    }
    wsSendJSON({ type: 'ping' });
  }, CFG.PING_INTERVAL_MS);
}

function stopPingLoop() {
  if (pingTimer) {
    clearInterval(pingTimer);
    pingTimer = null;
  }
}

export function disconnectWebSocket() {
  clearTimeout(reconnectTimer);
  stopPingLoop();
  if (ws) {
    try { ws.close(); } catch {}
    ws = null;
  }
}

export function sendTextMessage(text) {
  return wsSendJSON({ type: 'text_input', text });
}
// 已发布工作流列表
export function fetchPublishedWorkflowsApi(userId) {
  const path = "/api/v1/workflow/workflows";
  return dynamicService.get(path, { params: { user_id: userId, status: "published", page: 1, page_size: 100 } });
}
// Service API Key 管理
// Key 列表
export function fetchBotApiKeysApi(botId) {
  return dynamicService.get(`/api/v1/bot/${botId}/api-keys`);
}
// 创建 Key（明文只返回一次）
export function createBotApiKeyApi(botId, data) {
  return dynamicService.post(`/api/v1/bot/${botId}/api-keys`, data);
}
// 更新 Key（禁用/启用、改名、改限流）
export function updateBotApiKeyApi(botId, keyId, data) {
  return dynamicService.put(`/api/v1/bot/${botId}/api-keys/${keyId}`, data);
}
// 删除 Key
export function deleteBotApiKeyApi(botId, keyId) {
  return dynamicService.delete(`/api/v1/bot/${botId}/api-keys/${keyId}`);
}
